import React from 'react';
import styled from 'styled-components';
import TrueImpactButton, {
  TrueImpactButtonProps,
} from 'shared/design-system/components/TrueImpactButton';
import { CircularProgress } from '@mui/material';

interface TrueImpactPrimaryButtonProps extends TrueImpactButtonProps {
  isLoading?: boolean;
  top?: string;
  left?: string;
  buttonClassName?: string;
}

const StyledDiv = styled.div<{
  top: string;
  left: string;
  isLoading: TrueImpactPrimaryButtonProps['isLoading'];
}>`
  position: relative;
  .loading-button {
    position: absolute;
    top: ${({ top }) => top};
    left: ${({ left }) => left};
  }
`;

const TrueImpactPrimaryButton: React.FC<TrueImpactPrimaryButtonProps> = ({
  className,
  isLoading,
  top = '10px',
  left = '48%',
  buttonClassName,
  children,
  ...buttonProps
}) => {
  return (
    <StyledDiv top={top} left={left} isLoading={isLoading}>
      <TrueImpactButton
        {...buttonProps}
        disabled={isLoading || buttonProps.disabled}
        className={buttonClassName}
      >
        {children}
      </TrueImpactButton>
      {isLoading && <CircularProgress size={30} className="loading-button" />}
    </StyledDiv>
  );
};

export default TrueImpactPrimaryButton;
